import { ReactNode } from 'react';

/** Horizontal step indicator; connector fill animates via scaleX (styles/primitives.css). */
export function ProgressSteps({ steps }: { steps: { label: ReactNode; state: 'done' | 'active' | 'todo' }[] }) {
  return (
    <div className="psteps">
      {steps.map((s, i) => (
        <span key={i} style={{ display: 'contents' }}>
          {i > 0 && <span className={`bar${steps[i - 1].state === 'done' ? ' filled' : ''}`} />}
          <span className={`pstep ${s.state}`}>
            <span className="dot">{s.state === 'done' ? '✓' : i + 1}</span>
            <span className="lbl">{s.label}</span>
          </span>
        </span>
      ))}
    </div>
  );
}
